import { Observable } from 'rxjs';
import { FileValidationRule } from './file-validation-rule';

export const FILE_HEX_SIGNATURES = {
    PNG: '89504E47',
    PDF: '25504446',
    JPG: 'FFD8FF',
    BMP: '424D'
} as const;

export class FileSignatureValidationRule implements FileValidationRule {
    public readonly errorKey = 'invalidDatatype';

    /**
     * Liest die ersten 4 Bytes aus und prüft die “Magic Numbers”.
     * Wenn kein FileReader vorhanden ist, wird true zurückgegeben,
     * damit kein Validierungsfehler ausgelöst wird.
     */
    validate(file: File): Observable<boolean> {
        return new Observable<boolean>(subscriber => {
            const fileReaderConstructor = globalThis.FileReader;

            // Kein FileReader verfügbar → Validierung nicht möglich → als "ok" behandeln
            if (typeof fileReaderConstructor !== 'function') {
                subscriber.next(true);
                subscriber.complete();
                return undefined;
            }

            const reader = new fileReaderConstructor();
            const slice = file.slice(0, 4);

            reader.onloadend = (evt: ProgressEvent<FileReader>) => {
                if (evt.target?.readyState === fileReaderConstructor.DONE) {
                    try {
                        const uint = new Uint8Array(evt.target.result as ArrayBuffer);
                        const hex = Array.from(uint, b => b.toString(16).padStart(2, '0'))
                            .join('')
                            .toUpperCase();

                        const valid =
                            hex.startsWith(FILE_HEX_SIGNATURES.PNG) ||
                            hex.startsWith(FILE_HEX_SIGNATURES.PDF) ||
                            hex.startsWith(FILE_HEX_SIGNATURES.JPG) ||
                            hex.startsWith(FILE_HEX_SIGNATURES.BMP);

                        subscriber.next(valid);
                        subscriber.complete();
                    } catch {
                        subscriber.next(false);
                        subscriber.complete();
                    }
                }
            };

            reader.onerror = () => {
                subscriber.next(false);
                subscriber.complete();
            };

            try {
                reader.readAsArrayBuffer(slice);
            } catch {
                subscriber.next(false);
                subscriber.complete();
            }

            // Cleanup bei Unsubscribe
            return () => {
                try {
                    reader.abort();
                } catch {
                    // ignorieren
                }
            };
        });
    }
}